import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";

export class SetPatientSearchCriteria implements ReduxAction {
  type: string = "SET_PATIENT_SEARCH_CRITERIA";
  SearchCriteria: SearchCriteria;

  constructor(searchCriteria: SearchCriteria) {
    this.SearchCriteria = searchCriteria;
  }

  get() {
    return this.SearchCriteria;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/actions/patient-search.actions.ts